import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-article',
  standalone: true,
  imports: [CommonModule, BypassSecurityPipe],
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.less']
})
export class ArticleComponent {
  @Input() data: any;
}
